export default __webpack_public_path__ + "images/wms-features-icon.png";